/**
 * Global Country & Language Selector API
 *
 * Provides a simple interface to show/hide the country and language selector popup
 * from anywhere in your Shopify theme.
 *
 * @version 1.0.0
 */

(function (window) {
  'use strict'

  // Global API object
  const CountryLanguageSelector = {

    /**
     * Show the country/language selector popup
     * @param {Object} options - Optional configuration
     * @param {Function} options.onShown - Callback when popup is shown
     * @param {Function} options.onChanged - Callback when selection changes
     */
    show: function (options = {}) {
      const event = new CustomEvent('showCountryLanguageSelector', {
        detail: options
      })
      document.dispatchEvent(event)

      // Set up one-time listeners for callbacks
      if (options.onShown) {
        document.addEventListener('countryLanguageSelectorShown', options.onShown, { once: true })
      }
      if (options.onChanged) {
        document.addEventListener('countryLanguageChanged', options.onChanged, { once: true })
      }
    },

    /**
     * Hide the country/language selector popup
     * @param {Object} options - Optional configuration
     * @param {Function} options.onHidden - Callback when popup is hidden
     */
    hide: function (options = {}) {
      const event = new CustomEvent('hideCountryLanguageSelector', {
        detail: options
      })
      document.dispatchEvent(event)

      if (options.onHidden) {
        document.addEventListener('countryLanguageSelectorHidden', options.onHidden, { once: true })
      }
    },

    /**
     * Toggle the country/language selector popup
     * @param {Object} options - Optional configuration
     */
    toggle: function (options = {}) {
      const event = new CustomEvent('toggleCountryLanguageSelector', {
        detail: options
      })
      document.dispatchEvent(event)
    },


    /**
     * Check if popup is currently visible
     * @returns {boolean} True if popup is visible
     */
    isVisible: function () {
      const selector = document.getElementById('global-country-language-selector')
      return selector && selector.classList.contains('active')
    },

    /**
     * Initialize the selector (called automatically)
     * @private
     */
    init: function () {
      // Listen for DOM content loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.setupAutoTriggers.bind(this))
      } else {
        this.setupAutoTriggers()
      }
    },

    /**
     * Setup automatic triggers based on data attributes
     * @private
     */
    setupAutoTriggers: function () {
      // Find elements with data-country-selector-trigger attribute
      const triggers = document.querySelectorAll('[data-country-selector-trigger]')

      triggers.forEach(trigger => {
        const action = trigger.getAttribute('data-country-selector-trigger') || 'toggle'

        trigger.addEventListener('click', (e) => {
          e.preventDefault()

          switch (action) {
          case 'show':
            this.show()
            break
          case 'hide':
            this.hide()
            break
          case 'toggle':
          default:
            this.toggle()
            break
          }
        })
      })

      // Auto-show functionality
      const autoShow = document.querySelector('[data-country-selector-auto-show]')
      if (autoShow && !localStorage.getItem('country-selector-auto-shown')) {
        const delay = parseInt(autoShow.getAttribute('data-country-selector-auto-show')) || 0

        setTimeout(() => {
          this.show()
          localStorage.setItem('country-selector-auto-shown', 'true')
        }, delay)
      }
    }
  }

  // Auto-initialize
  CountryLanguageSelector.init()

  // Expose to global scope
  window.CountryLanguageSelector = CountryLanguageSelector

  // Also expose as shorter alias
  window.CLS = CountryLanguageSelector
})(window)

